import {createSinglePathSVG} from './TEMPLATE'

/**
 * A school: a building with a roof, a door and a window either side.
 *
 * A classroom is run by a school, and the set had nothing to draw one with: the
 * institution was drawn as a person (`Person_Stroke2_Corner0_Rounded`), which
 * says a school is somebody's profile rather than somewhere with a door. This is
 * the shape it is instead — a gable over a body, a ground line, an arched door
 * and a window each side — drawn as strokes rather than as outlines, so the
 * detail survives being drawn at the size a menu item draws it.
 */
export const School_Stroke2_Corner0_Rounded = createSinglePathSVG({
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M12 2.9 3 9.5h18L12 2.9Zm-7.1 6.6v10.2h14.2V9.5M2.9 19.7h18.2M9.9 19.7v-4.4a2.1 2.1 0 0 1 4.2 0v4.4M6.7 12.5h2.1v2.1H6.7zM15.2 12.5h2.1v2.1h-2.1z',
})
